"use client"

import { useEffect } from "react"

interface FontLoaderProps {
  headingFont: string
  bodyFont: string
}

export function FontLoader({ headingFont, bodyFont }: FontLoaderProps) {
  useEffect(() => {
    // Remove existing font links
    const existingLinks = document.querySelectorAll('link[data-font-loader]')
    existingLinks.forEach(link => link.remove())

    // Load heading font if not default
    if (headingFont && headingFont !== 'Bebas Neue') {
      const headingLink = document.createElement('link')
      headingLink.rel = 'stylesheet'
      headingLink.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(headingFont.replace(/\s+/g, '+'))}:wght@400;700&display=swap`
      headingLink.setAttribute('data-font-loader', 'heading')
      document.head.appendChild(headingLink)
    }

    // Load body font if not default
    if (bodyFont && bodyFont !== 'Geist') {
      const bodyLink = document.createElement('link')
      bodyLink.rel = 'stylesheet'
      bodyLink.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(bodyFont.replace(/\s+/g, '+'))}:wght@300;400;500;600;700&display=swap`
      bodyLink.setAttribute('data-font-loader', 'body')
      document.head.appendChild(bodyLink)
    }

    // Apply fonts via CSS variables
    document.documentElement.style.setProperty('--font-heading', headingFont || 'Bebas Neue')
    document.documentElement.style.setProperty('--font-body', bodyFont || 'Geist')
  }, [headingFont, bodyFont])

  return null
}
